export class NICEBusinessUnit {
    businessUnitId: number;
    businessUnitName: string;
    globalCallerId: string;
    phoneTimeout: number;
    userSessionTimeout: number;
    startDayOfWeek: number;
    defaultTimeZone: string;
    agentsUseDefaultTimeZone: boolean;
    maxScriptHistory: number;
    authGUID: string;
    coBrand: boolean;
    coBrandProfileId: number;
    coBrandProfileName: string;
    connectivityType: string;
    clientConnectorPort: number;
    callSuppression: boolean;
    priorityBasedBlending: boolean;
    enableFiltering: boolean;
    allowPredictiveDialing: boolean;
    enableTrueBlending: boolean;
    enableSkillAbandonRate: boolean;
    abandonRateScope: number;
    defaultConfirmationDeliveryModeId: number;
    defaultConfirmationDeliveryMode: string;
    defaultComplianceRecordTypeId: number;
    defaultComplianceRecordType: string;
    defaultContactExpirationMinutes: number;
    daysUntilListSourceIsFlaggedForDeletion: number;
    scriptNamespace: string;
    apiPublishedLimit: number;
    concurrentPortLimit: number;
    ivrSurveyCallbackLimit: number;
    stationLimit: number;
    userLimit: number;
    concurrentAgentLimit: number;
    outboundPortLimit: number;
    agentlessPortLimit: number;
    maxConferenceParties: number;
    custom1: string;
    custom2: string;
    custom3: string;
    custom4: string;
    custom5: string;
    isActive: boolean;
    presenceMasterId: number;
    tenantId: string;
    parentTenantId: string;
    features: Feature[];
    fileExtensions: FileExtension[];
    timeZones: TimeZone[];
    parentBusinessUnitID: number;
    isIntegratedTenant: boolean;
    niceEngageConfigId: number;
    niceWFMConfigID: number;
    niceQMTenantID: number;
    niceWFMTenantId: number;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ieX_CustomerName: string;
    isMultiContactHandling: boolean;
    enableMaxReleasePreview: boolean;
    isVFMEnabled: boolean;
    maxClientVersion: number;
    permitPerAgentVersioning: boolean;
    permitDevVersion: boolean;
    defaultToPrevious: boolean;
    emergencyCallNotificationEmail: string;
    aacAdmins: string[] = [];
    aacMaxAdminCount = 0;
}


    export class Feature {
        productId: number;
        productDescription: string;
        isEnabled: boolean;
    }

    export class FileExtension {
        extension: string;
    }

    export class TimeZone {
        displayName: string;
        standardName: string;
    }
